import * as React from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import moment from "moment";

export default function EnqDetails({ state, toggleDrawer, detailsData }) {
  const list = (anchor) => (
    <Box sx={{ width: 450 }} role="presentation">
      <div className="container">
        <div className="row">
          <div className="col-12 details-inquiry-heading">
            <span
              onClick={() => {
                toggleDrawer(anchor, false);
              }}
            >
              <ClearOutlinedIcon />
            </span>
            <p>Inquiry Details</p>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Transport mode</div>
              <div>{detailsData?.Inquiry_TransportMode ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Movement Type</div>
              <div>{detailsData?.Inquiry_MovementType ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Origin country</div>
              <div>{detailsData?.Inquiry_OriginCountry ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Origin Port</div>
              <div>{detailsData?.Inquiry_OriginPort ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Origin City Pincode</div>
              <div>{detailsData?.Inquiry_OriginPinCode ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Destination country</div>
              <div>{detailsData?.Inquiry_DestinationCountry ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Destination  Port</div>
              <div>{detailsData?.Inquiry_DestinationPort ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Destination city Pincode</div>
              <div>{detailsData?.Inquiry_DestinationPinCode ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Inco Term</div>
              <div>{detailsData?.Inquiry_IncoTerm ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Cargo Type</div>
              <div>{detailsData?.Inquiry_CargoType ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Remarks</div>
              <div>{detailsData?.Inquiry_Remarks ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Assigned Staff</div>
              <div>{detailsData?.Inquiry_AssignedTo ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Status</div>
              <div>{detailsData?.Inquiry_Status ?? "N/A"}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Enquiry Date</div>
              <div>
                {moment(detailsData?.Inquiry_CreatedOn).format("MM-DD-YYYY") ??
                  "N/A"}
              </div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Enquiry Id</div>
              <div>{detailsData?.Id}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-page">
            <div>
              <div>Enquiry Type</div>
              <div>{detailsData?.Inquiry_Type}</div>
            </div>
          </div>
          <div className="col-12 details-inquiry-cargo">
            <p>Cargo Details</p>
          </div>
          {detailsData?.Inquiry_TransportMode &&
          detailsData?.Inquiry_TransportMode.toLowerCase().includes("sea") ? (
            <div className="cargo-card">
              {[1, 2].map(() => {
                return (
                  <div className="details-cargo-card">
                    <div className="container">
                      <div className="row">
                        <div className="col-4">
                          <p>Package Type</p>
                          <p>N/A</p>
                        </div>
                        <div className="col-4">
                          <p>Quantity</p>
                          <p>N/A</p>
                        </div>
                        <div className="col-4">
                          <p>Weight per piece</p>
                          <p>N/A</p>
                        </div>
                        <div className="col-3">
                          <p>Length </p>
                          <p>N/A</p>
                        </div>
                        <div className="col-3">
                          <p>Width</p>
                          <p>N/A</p>
                        </div>
                        <div className="col-3">
                          <p>Height</p>
                          <p>N/A</p>
                        </div>
                        <div className="col-3">
                          <p>Stackable</p>
                          <p>N/A</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : detailsData?.Inquiry_TransportMode &&
            detailsData?.Inquiry_TransportMode.toLowerCase().includes("air") ? (
            <div className="cargo-card">
              {[1, 2].map(() => {
                return (
                  <div className="details-cargo-card">
                    <div className="container">
                      <div className="row">
                        <div className="col-6">
                          <p>Container Type</p>
                          <p>N/A</p>
                        </div>
                        <div className="col-6">
                          <p>Quantity</p>
                          <p>N/A</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      </div>
    </Box>
  );

  console.log({ detailsData });

  return (
    <>
      <SwipeableDrawer
        anchor={"right"}
        open={state}
        onClose={() => toggleDrawer("right", false)}
        onOpen={() => toggleDrawer("right", true)}
      >
        {list("right")}
      </SwipeableDrawer>
    </>
  );
}
